import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms';

export const isRequiredField = (field: FrontendFieldDefinition): boolean =>
    Boolean(field.validators?.some(({ kind }) => kind === 'form_validator_required' || kind === 'required'));
